import React from 'react';
import { Option } from '@spike/model';
import MultipleSelector from 'components/UI/V3/MultipleSelector';
import { FilterRow } from './FilterRow';

interface FilterMultiSelectRowProps {
    label: string;
    placeholder?: string;
    enabled: boolean;
    onToggle: () => void;
    options: Array<Option<string>>;
    selectedIds: Array<string>;
    onChange: (selectedIds: Array<string>) => void;
}

export const FilterMultiSelectRow: React.FC<FilterMultiSelectRowProps> = ({
    label,
    placeholder,
    enabled,
    onToggle,
    options,
    selectedIds,
    onChange
}) => {
    const selectedLabel =
        options
            .filter(o => selectedIds.includes(o.id))
            .map(o => o.name)
            .join(', ') || undefined;

    return (
        <FilterRow
            label={label}
            enabled={enabled}
            onToggle={onToggle}
        >
            <MultipleSelector
                options={options}
                selectedIds={selectedIds}
                placeholder={placeholder ?? label}
                selectedLabel={selectedLabel}
                onChange={onChange}
            />
        </FilterRow>
    );
};
